import React, { useState } from 'react';
import { Banknote } from 'lucide-react';
import ManagementPage from '../../Common/components/common/ManagementPage';
import DetailItem from '../../Common/components/common/DetailItem';
import DetailGrid from '../../Common/components/common/DetailGrid';
import { useToast } from '../../Common/context/ToastContext';

const deposits = [
  { id: 'S1', approveDate: '26.01.27', approveAmount: '1,000,000', approveCount: 3, settleDate: '26.01.29', settleAmount: '1,000,000', settleCount: 3, depositDate: '26.01.29', merchant: 'A가맹점', status: '입금완료', txId: 'TX-992011' },
  { id: 'S2', approveDate: '26.01.27', approveAmount: '1,240,000', approveCount: 2, settleDate: '26.01.29', settleAmount: '1,200,000', settleCount: 2, depositDate: '26.01.29', merchant: 'A가맹점', status: '입금완료', txId: 'TX-992012' },
  { id: 'S3', approveDate: '26.01.27', approveAmount: '3,500,000', approveCount: 5, settleDate: '26.01.29', settleAmount: '3,500,000', settleCount: 5, depositDate: '26.01.29', merchant: 'B가맹점', status: '입금완료', txId: 'TX-992013' },
];

function Deposits() {
  const { showToast } = useToast();
  const [selectedItem, setSelectedItem] = useState(null);
  const [startDate, setStartDate] = useState('2026.01.29');
  const [endDate, setEndDate] = useState('2026.01.29');

  const setQuickPeriod = (type) => {
    const today = new Date();
    const formatDate = (d) => `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
    const parseDate = (s) => {
      const [y, m, d] = s.split('.').map(Number);
      return new Date(y, m - 1, d);
    };
    let currentStart = parseDate(startDate);
    let newStart, newEnd;
    switch (type) {
      case '당일': newStart = newEnd = today; break;
      case '전일':
        newStart = new Date(currentStart); newStart.setDate(currentStart.getDate() - 1);
        newEnd = new Date(newStart);
        break;
      case '당월': newStart = new Date(today.getFullYear(), today.getMonth(), 1); newEnd = today; break;
      case '전월':
        newStart = new Date(currentStart.getFullYear(), currentStart.getMonth() - 1, 1);
        newEnd = new Date(currentStart.getFullYear(), currentStart.getMonth(), 0);
        break;
      default: return;
    }
    setStartDate(formatDate(newStart));
    setEndDate(formatDate(newEnd));
  };

  // 기간별 통계 계산
  const totalCount = deposits.length;
  const totalDepositAmount = deposits.reduce((sum, item) => {
    return sum + Number(String(item.settleAmount).replace(/,/g, ''));
  }, 0);
  const totalApproveAmount = deposits.reduce((sum, item) => {
    return sum + Number(String(item.approveAmount).replace(/,/g, ''));
  }, 0);
  const totalSettleAmount = deposits.reduce((sum, item) => {
    return sum + Number(String(item.settleAmount).replace(/,/g, ''));
  }, 0);
  const totalApproveCount = deposits.reduce((sum, item) => sum + (item.approveCount || 0), 0);
  const totalSettleCount = deposits.reduce((sum, item) => sum + (item.settleCount || 0), 0);

  return (
    <div className="relative flex-1 flex flex-col min-h-0 overflow-hidden bg-white">
      <ManagementPage
        title="입금완료"
        emptyStateIcon={<Banknote size={32} className="opacity-20" />}
        hideSearch={false}
        filters={
          <div className="flex items-center gap-3">
            <div className="h-4 w-[1px] bg-[#e5e8eb]" />
            {/* <span className="text-[14px] font-bold text-[#4e5968] shrink-0">조회 기간</span> */}
            <div className="h-[42px] flex items-center gap-1.5 bg-[#f2f4f6] px-3 rounded-lg border border-transparent focus-within:border-[var(--brand-primary)] transition-all">
              <input
                type="date"
                value={startDate.replace(/\./g, '-')}
                onChange={(e) => setStartDate(e.target.value.replace(/-/g, '.'))}
                className="bg-transparent border-none outline-none text-[14px] font-mono text-[#191f28] py-0 h-full"
              />
              <span className="text-[#8b95a1] text-[12px]">~</span>
              <input
                type="date"
                value={endDate.replace(/\./g, '-')}
                onChange={(e) => setEndDate(e.target.value.replace(/-/g, '.'))}
                className="bg-transparent border-none outline-none text-[14px] font-mono text-[#191f28] py-0 h-full"
              />
            </div>
            <div className="flex gap-1">
              {['당일', '전일', '당월', '전월'].map((type) => (
                <button
                  key={type}
                  onClick={() => setQuickPeriod(type)}
                  className="px-2.5 py-1.5 bg-white border border-[#e5e8eb] rounded-lg text-[12px] font-bold text-[#4e5968] hover:bg-[#f2f4f6] leading-none h-[42px] flex items-center"
                >
                  {type}
                </button>
              ))}
            </div>
          </div>
        }
        leftActions={
          <div className="text-[16px] font-bold text-[#191f28]">
          총 입금 금액: <span className="text-[var(--brand-primary)]">{totalDepositAmount.toLocaleString()}원</span> ({totalCount}건)
          </div>
        }
        onExcelDownload={() => showToast('엑셀 다운로드가 시작되었습니다.')}
        onDetailButtonClick={() => showToast('이메일로 전표가 전송되었습니다.')}
        tableHeaders={
          <>
            <th className="px-4 py-3">가맹점명</th>
            <th className="px-4 py-3">승인일/금액</th>
            <th className="px-4 py-3">정산일/금액</th>
            <th className="px-4 py-3">입금일/입금금액</th>
            <th className="px-4 py-3">ID</th>
          </>
        }
        data={deposits}
        renderRow={(item) => (
          <>
            <td className="px-4 py-3 font-bold text-[#191f28] underline underline-offset-4 decoration-[#adb5bd]">{item.merchant}</td>
            <td className="px-4 py-3 font-medium">{item.approveDate}<br /><span className="text-[#191f28] font-bold">{item.approveAmount}</span></td>
            <td className="px-4 py-3 font-medium">{item.settleDate}<br /><span className="text-[var(--brand-primary)] font-bold">{item.settleAmount}</span></td>
            <td className="px-4 py-3 font-medium text-[var(--brand-primary)]">{item.depositDate}<br /><span className="font-bold">{item.settleAmount}</span></td>
            <td className="px-4 py-3 font-mono text-[#4e5968]">{item.id}</td>
          </>
        )}
        detailTitle="입금 상세정보"
        detailButtonLabel={selectedItem ? "전표" : undefined}
        selectedItem={selectedItem}
        onSelectItem={setSelectedItem}
        renderDetail={(item) => (
          <DetailGrid>
            <DetailItem label="ID" value={item.id} />
            <DetailItem label="가맹점명 (입금처)" value={item.merchant} />
            <DetailItem label="승인번호" value={item.txId} />
            <DetailItem label="상태" value={item.status} color="var(--brand-primary)" />
            <DetailItem label="승인일" value={item.approveDate} />
            <DetailItem label="승인금액(건수)" value={`${item.approveAmount}(${item.approveCount})`} />
            <DetailItem label="정산일" value={item.settleDate} />
            <DetailItem label="정산금액(건수)" value={`${item.settleAmount}`} color="var(--brand-primary)" />
            <DetailItem label="입금일" value={item.depositDate} />
            <DetailItem label="입금금액" value={item.settleAmount} color="var(--brand-primary)" />
          </DetailGrid>
        )}
      />
    </div>
  );
}

export default Deposits;
